// extracted by mini-css-extract-plugin
export default {"model":"PopUpTemplate_model__zX8X5","overlay":"PopUpTemplate_overlay__nekOz","childDiv":"PopUpTemplate_childDiv__mMlbY"};